module.exports = __webpack_public_path__ + "static/media/des3.019c7dd1.jpg";